module.exports = __webpack_public_path__ + "img/favorites-fill.8e5b73a.svg?v=1762502055057";